/**
 * Custom: boltvalget på produktsiden er obligatorisk (se snippets/bolt-choice.liquid).
 * Stopper "Læg i kurv", hvis der ikke er valgt en bolt.
 */
(() => {
  const check = (e, form) => {
    if (!form) return;
    const choice = form.querySelector('[data-bolt-choice]');
    if (!choice) return;
    if (choice.querySelector('input[type="radio"]:checked')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const error = choice.querySelector('[data-bolt-choice-error]');
    if (error) error.textContent = choice.dataset.error;
    choice.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  // Formularen sendes
  document.addEventListener('submit', (e) => check(e, e.target.closest('form')), true);

  // Klik på "Læg i kurv" (hvis temaet håndterer klikket selv)
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('.add-to-cart, button[type="submit"][name="add"]');
      if (btn) check(e, btn.closest('form'));
    },
    true
  );

  // Fjern fejlbeskeden når der vælges
  document.addEventListener('change', (e) => {
    const choice = e.target.closest('[data-bolt-choice]');
    if (!choice) return;
    const error = choice.querySelector('[data-bolt-choice-error]');
    if (error) error.textContent = '';
  });
})();
